import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { renderCurrencySymbol } from '../../utils/helpers/currencies';

import CurrencyInputInline from '../currency-input-inline';


const wrapperStyle = {
  borderLeft: '1px solid #ddd',
};

class CampaignBudget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      budget: this.props.budget,
      budgetPersistent: this.props.budget,
      editing: false,
    };
  }

  changeBudget = value => {
    this.setState({ budget: value });
  };

  updateBudget = () => {
    this.setState({
      budgetPersistent: this.state.budget,
      editing: false,
    });
    this.props.updateBudget(this.state.budget);
  };

  resetBudget = () => {
    this.setState({
      budget: this.state.budgetPersistent,
      editing: false,
    });
  };

  setEditing = () => {
    this.setState({ editing: true });
  };

  render() {
    const { allocated, updated, handleSubmit, currency } = this.props;
    const { budget, budgetPersistent, editing } = this.state;
    const remainder = budget - allocated || 0;

    return (
      <div style={wrapperStyle}>
        <div className="row">
          <div className="flex-spacer" />
          <div className="flex-item">
            <p className="input-label"><strong>Total budget:</strong></p>
          </div>
          <div className="flex-item">
            <CurrencyInputInline
              id="budget"
              name="budget"
              currency={currency}
              disabled={!editing}
              value={budget}
              onChange={this.changeBudget}
              onFocus={() => this.setState({ editing: true })}
              placeholder={0}
              editable
            />
          </div>
          <div className="flex-item" style={{ whiteSpace: 'nowrap' }}>
            { editing
              ? <span>
                <button className="medium grey-icon" onClick={this.updateBudget} >
                  <img src="/icons/tick-seagreen.svg" alt="save" />
                </button>
                <button className="medium grey-icon" onClick={this.resetBudget} >
                  <img src="/icons/close-red.svg" alt="cancel" />
                </button>
              </span>
              : <button className="medium grey-icon" onClick={this.setEditing}>
                <img src="/icons/edit.svg" alt="edit" />
              </button>
            }
          </div>
          <div className="flex-item">
            <p className="input-label"><strong>Allocated:</strong></p>
          </div>
          <div className="flex-item">
            <CurrencyInputInline
              id="allocated"
              name="allocated"
              value={allocated}
              currency={currency}
              placeholder={0}
              disabled
            />
          </div>
        </div>
      </div>
    );
  }
}

CampaignBudget.propTypes = {
  updateBudget: PropTypes.func.isRequired,
};

export default CampaignBudget;



/** WEBPACK FOOTER **
 ** ./src/components/campaign-budget/index.js
 **/